import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, TwitterIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 py-12" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-16">
          {/* About Section */}
          <div data-id="element-17">
            <h3 className="text-xl font-bold mb-4 text-amber-400" data-id="element-18">About Us</h3>
            <p className="text-gray-300 text-sm leading-relaxed mb-4" data-id="element-19">
              Your trusted platform for discovering and booking tables at the
              finest restaurants across the Maldives.
            </p>
            <div className="flex gap-3" data-id="element-20">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-blue-600 p-2 rounded-lg transition-colors" data-id="element-21">
                <FacebookIcon className="w-5 h-5" data-id="element-22" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-pink-600 p-2 rounded-lg transition-colors" data-id="element-23">
                <InstagramIcon className="w-5 h-5" data-id="element-24" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-blue-400 p-2 rounded-lg transition-colors" data-id="element-25">
                <TwitterIcon className="w-5 h-5" data-id="element-26" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-27">
            <h3 className="text-xl font-bold mb-4 text-amber-400" data-id="element-28">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-29">
              <li data-id="element-30">
                <Link to="/" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-31">
                  Home
                </Link>
              </li>
              <li data-id="element-32">
                <Link to="/restaurants" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-33">
                  All Restaurants
                </Link>
              </li>
              <li data-id="element-34">
                <Link to="/about" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-35">
                  About Us
                </Link>
              </li>
              <li data-id="element-36">
                <Link to="/contact" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-37">
                  Contact
                </Link>
              </li>
              <li data-id="element-38">
                <Link to="/faq" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-39">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div data-id="element-40">
            <h3 className="text-xl font-bold mb-4 text-amber-400" data-id="element-41">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-42">
              <li data-id="element-43">
                <Link to="/terms" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-44">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/privacy" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-46">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/cancellation" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-48">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/refund" className="text-gray-300 hover:text-amber-400 transition-colors" data-id="element-50">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-51">
            <h3 className="text-xl font-bold mb-4 text-amber-400" data-id="element-52">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-53">
              <li className="flex items-start gap-2" data-id="element-54">
                <MapPinIcon className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-55" />
                <span className="text-gray-300" data-id="element-56">Malé City, Maldives</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-57">
                <PhoneIcon className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-58" />
                <span className="text-gray-300" data-id="element-59">+960 123-4567</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-60">
                <MailIcon className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-61" />
                <span className="text-gray-300" data-id="element-62">info@iftarbooking.mv</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 mt-6" data-id="element-63">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-64">
            <p className="text-sm text-gray-400" data-id="element-65">
              © {new Date().getFullYear()} DineReserve.mv. All rights reserved.
            </p>
            <p className="text-sm text-gray-400" data-id="element-66">
              Made with ❤️ in the Maldives
            </p>
          </div>
        </div>
      </div>
    </footer>;
}